import React from "react";
import "./Blog.css";

import { useTranslation } from "react-i18next";
import i18n from "i18next";
import axios from 'axios';
import { Link } from "react-router-dom";

const Blog = () => {
    const { t } = useTranslation();

    document.title = t("page-title.blog");

    const lang = i18n.language;
    const [posts, setPosts] = React.useState([]);
    const [loading, setLoading] = React.useState(true);
    const [visibleCount, setVisibleCount] = React.useState(9);

    const apiUrl = 'https://docs.ngen-group.eu/api/';
    const language = lang.substring(0, 2);

    const formatPostDate = (dateString, language) => {
        if (!dateString) return "";
        const date = new Date(dateString);
        const options = { day: '2-digit', month: 'short', year: 'numeric' };
        return new Intl.DateTimeFormat(language, options).format(date);
    };

    React.useEffect(() => {
        const config = {
            method: 'get',
            maxBodyLength: Infinity,
            url: `${apiUrl}posts?lang=${language}`,
            headers: {
                'Authorization': 'Bearer jmLIFRUUGy9y7TmI7EfTBMmkYRt6YVajU0iLZMM7e9d64afa'
            }
        };

        axios.request(config)
            .then(response => {
                const allPosts = response.data;
                const sortedPosts = allPosts.sort(
                    (a, b) => new Date(b.created_at) - new Date(a.created_at)
                );
                setPosts(sortedPosts);
                setLoading(false);
            })
            .catch(error => {
                console.error('Error fetching posts:', error);
            });
    }, [language]);

    const latestPost = posts[0];
    const otherPosts = posts.slice(1);
    const visiblePosts = otherPosts.slice(0, visibleCount);

    return (
        <div className="UIBlog">
            <div className="container-fluid background">
                <div className="container">
                    <div className="row">
                        <div className="col-sm-12 col-md-12 col-lg-7 blog-header">
                            <div className="heading">
                                <h2>{t("pages.blog_1")}</h2>
                                <h1>{t("pages.blog")}</h1>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="container content">
                {/* Latest Post */}
                {latestPost && (
                    <div className="row latest">
                        <div className="col-md-6 col-sm-12">
                            <img src={`https://${latestPost.image}`} alt={`${latestPost.title}`} />
                        </div>
                        
                        <div className="col-md-6 col-sm-12 content">
                            <div>
                                <div className="date">{formatPostDate(latestPost.created_at, language)}</div>
                                <h3>{latestPost.title}</h3>
                                <p>{latestPost.short_description}</p>
                            </div>
                            <Link to={`${t('url.post')}/${latestPost.slug}-${latestPost.id}`} className="btn-primary">
                                {t("blog.read-more")}
                            </Link>
                        </div>
                    </div>
                )}
            </div>

            <div className="container content my-5">
                {visiblePosts.length > 0 && (
                    <div className="row posts">
                        {visiblePosts.map((post, index) => (
                            <div className="col-lg-4 col-md-6 col-sm-12 post" key={index}>
                                <Link to={`${t('url.post')}/${post.slug}-${post.id}`} className="post-content">
                                    <img src={`https://${post.image}`} alt={`${post.title}`} />
                                    <div className="date">{formatPostDate(post.created_at, language)}</div>
                                    <h4>{post.title}</h4>
                                    <p>{post.short_description}</p>
                                </Link>
                            </div>
                        ))}
                    </div>
                )}

                {/* Load More Button */}
                {visibleCount < otherPosts.length && (
                    <div className="text-center mt-4">
                        <button 
                            className="btn-primary"
                            onClick={() => setVisibleCount(prev => prev + 9)}
                        >
                            {t("blog.load-more")}
                        </button>
                    </div>
                )}
            </div>
        </div>
    );
};
export default Blog;